import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M4 17.1v-11h16v3.5c.7 0 1.4.2 2 .6V6.1c0-.5-.2-1-.6-1.4s-.9-.6-1.4-.6H4c-.5 0-1 .2-1.4.6S2 5.5 2 6.1v11c0 .5.2 1 .6 1.4s.9.6 1.4.6h9.2c-.4-.6-.6-1.3-.6-2z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M22.1 11.5q-.9-.9-2.1-.9c-1.2 0-1.5.3-2.1.9l-3.4 3.4q-.9.9-.9 2.1c0 1.2.3 1.5.9 2.1q.9.9 2.1.9c1.2 0 1.5-.3 2.1-.9l3.4-3.4q.9-.9.9-2.1c-.1-.9-.3-1.6-.9-2.1m-4.8 6.2c-.2.2-.5.3-.7.3-.3 0-.5-.1-.7-.3s-.3-.5-.3-.7.1-.5.3-.7l1.1-1.1 1.5 1.5zm3.4-3.4-1.1 1.1-1.5-1.5 1.1-1.1c.2-.2.5-.3.7-.3.3 0 .5.1.7.3s.3.5.3.7c.2.3.1.6-.2.8m-13.4 0c.2.2.4.3.7.3s.5-.1.7-.3.3-.4.3-.7v-1h1c.3 0 .5-.1.7-.3s.3-.4.3-.7-.1-.5-.3-.7-.4-.3-.7-.3H9v-1c0-.3-.1-.6-.3-.7-.2-.2-.4-.3-.7-.3s-.5.1-.7.3c-.2.1-.3.4-.3.7v1H6c-.3 0-.5.1-.7.3-.2.1-.3.4-.3.7s.1.5.3.7.4.3.7.3h1v1c0 .3.1.5.3.7m9.9-3.5c.5-.5 1.1-.8 1.7-1 0-.1-.1-.2-.2-.2-.1-.1-.3-.2-.5-.2h-4.5c-.2 0-.4.1-.5.2s-.2.3-.2.5.1.4.2.5.3.2.5.2zm-4 1.7c-.1.1-.2.3-.2.5s.1.4.2.5.3.2.5.2h.4l1.5-1.5h-1.9c-.2.1-.3.2-.5.3" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }